module.exports = __webpack_public_path__ + "img/input-minus.10b963d7.svg";